/**
 * Where the marketing site hands off to the product. Every action CTA on this
 * landing page — "Get Help Now", "Ask a Question", "Request Vetting", and
 * so on — points here rather than to a dead "#". Kept in one place so the
 * handoff target can change (staging, a new domain) without touching every
 * component that links to it.
 */
export const APP_URL = "https://user.swamithra.com"

/** Sign-in for the Expert panel, linked from the footer for panel members. */
export const EXPERT_PANEL_URL = `https://experts.swamithra.com`

/**
 * Canonical origin of this marketing site — used for `<link rel="canonical">`
 * and Open Graph `og:url` tags. PLACEHOLDER: replace once the production
 * domain is assigned; a wrong canonical is worse than a missing one, so don't
 * guess further than this.
 */
export const SITE_URL = "https://www.swamithra.com"

/** Store listings for the mobile app. Update once they're published. */
export const APP_STORE_URL = "https://apps.apple.com/app/swamithra"
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=in.swamithra.app"

/**
 * Spread onto any `<a>` that leaves this site (the product handoff, app store
 * listings) so it opens in a new tab. `noopener` stops the new tab from
 * getting a `window.opener` handle back to this page; `noreferrer` on top
 * covers older browsers that don't respect `noopener` alone.
 */
export const externalLinkProps = {
	target: "_blank",
	rel: "noopener noreferrer",
} as const
